export default {
  timeout: 100000, // 请求超时时间
  /**
   * @description 请求基地址
   */
  baseURL: '/eshop',
  /**
   * @description mock接口基地址
   */
  mockBaseURL: '/mock',
  /**
   * @description cookie相关键值
   */
  cookie: {
    TOKEN: 'Eshop-Backend-Access-Token', // Eshop-Backend-Access-Token
    NEED_VCODE: 'eshop_need_verification_code',
    USER_AGENT: 'eshop_user_agent',
    SUBMIT_TOKEN: 'Eshop-Form-Submit-Token'
  },
  /**
   * @description 请求需要携带的自定义Header
   */
  headers: {
    TOKEN: 'Eshop-Access-Token',
    USER_AGENT: 'Eshop-User-Agent',
  },
  modules: { // 中台模块配置，id与后台保持一致
    OM: { // 运营模块
      id: 1,
      key: 'OM',
      prefix: 'om',
      name: '运营模块',
      url: '/om',
      meta: {
        path: '/om',
        name: 'home',
        meta: {
          title: '首页',
          home: true,
          hide: true,
          ignoreBreadCrumb: true
        }
      }
    },
    SELF: { // 自营模块
      id: 4,
      key: 'SELF',
      prefix: 'self',
      name: '自营模块',
      url: '/self',
      meta: {
        path: '/self',
        name: 'self-home',
        meta: {
          title: '首页',
          home: true,
          ignoreBreadCrumb: true
        }
      }
    }
  },
  /**
   * @description 菜单配置，用于生成菜单
   */
  router: {
    routesKey: 'routes', // 路由列表
    menusKey: 'menuList', // 菜单列表
    isMenuKey: 'isMenu', // 是否为菜单标识
    urlKey: 'router', // url键值
    whiteList: [ // 路由白名单
      '/om',
      '/self',
      '/self/',
      '/om/'
    ],
    idKey: 'id', // 菜单唯一标志
    labelKey: 'name', // 菜单名称
    iconKey: 'icon', // 菜单图标
    childrenKey: 'children' // 下级菜单键值
  },
  /**
   * @description 权限列表键值
   */
  authsKey: 'funList',
  /**
   * @description 权限编码键值，当权限列表元素为对象时有效
   */
  authCodeKey: 'code',
  /**
   * @description ueditor配置
   */
  ueditor: {
    serverUrl: '/eshop/editor/file',
    initialFrameHeight: 600,
    autoFloatEnabled: false,
    autoHeightEnabled: false,
    initialFrameWidth: '100%',
    enableAutoSave: false,
    catchRemoteImageEnable: false
  },
  tagNavList: {
    max: 10, // TODO 没提就不做
    cache: true,
    logoutClearList: true
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js